'use client'

import React, { useContext } from "react";
import { PaginationProps } from "./LotPagination";
import { Flex, Text } from "@radix-ui/themes";
import { DisplayType } from "@/lib/enum/PaginationInfoDisplayTypes";
import { cn } from "@/lib/utils";
import { AuctionFilterContext } from "@/lib/context/AuctionFilterContext";
import { useSearchParams } from "next/navigation";
import { AUCTION_CATALOGUE_DEFAULT_PAGE_SIZE } from "@/lib/constants";

interface ExtendedPaginationProps extends PaginationProps {
  itemLabel?: string;
  display?: DisplayType;
}
const LotsCurrentPageInfo = ({
  className,
}: ExtendedPaginationProps) => {
  const searchParams = useSearchParams();
  const currentPage = parseInt(searchParams.get('page') || '1');
  const pageSize = parseInt(searchParams.get('pageSize') || AUCTION_CATALOGUE_DEFAULT_PAGE_SIZE.toString());

  const auctionFilterContext = useContext(AuctionFilterContext);
  const itemCount = auctionFilterContext?.itemCount || 0;
  const first = Math.min((currentPage - 1) * pageSize + 1, itemCount);
  const last = Math.min(currentPage * pageSize, itemCount);

  return (
    <Flex className={cn("mr-4", className)}>
      <Text className="text-xs ">{`Showing lots ${first} to ${last} of ${itemCount}`}</Text>
    </Flex>
  );
};

export default LotsCurrentPageInfo;
